import { combineReducers, configureStore } from "@reduxjs/toolkit";
import user from "./user/userSlice";
import serviceData from "./serviceData/serviceSlice";

const rootReducer = combineReducers({
  user: user,
  serviceData: serviceData,
});

export const store = configureStore({
  reducer: rootReducer,
});
